

const updateHeaderPinnedCount = (newValue) => {
   const pinnedValues = [...document.querySelectorAll('[data-js-pinned-value]')];
   pinnedValues.forEach(location => {
      location.innerText = newValue;
   });
};

export default updateHeaderPinnedCount;